module.exports = __webpack_public_path__ + "img/轻雾.de011fcb.png";